import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSingleCCFPointsAPI } from "../../apiConfig/apiCall";

export const getCCFPointDetails = createAsyncThunk('getCCfPointDetails', async (ID) => {
    const response = await getSingleCCFPointsAPI(ID);
    return response.data;
});

const getCCFPointDetailSlice = createSlice({
    name: "getCCfPointDetails",
    initialState: {
        isLoading: false,
        isError: false,
        data: {},
    },
    extraReducers: (builder) => {
        builder.addCase(getCCFPointDetails.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getCCFPointDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getCCFPointDetails.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getCCFPointDetailSlice.reducer;